import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {Endorsement} from '../Endorsement'
import { renderEndorsements } from '../utils'

import './endorsements.css'

class Endorsements extends Component {

  render () {
    let data = this.props.data;
    let endorsements = renderEndorsements(data.endorsement_list); 

    return (
      <div>
        <Title name = {data.title}></Title>
        {endorsements}
      </div>
    );
  }
}


export default {Endorsements}



// WEBPACK FOOTER //
// ./src/components/Endorsements/index.js